import CryptoJS from 'crypto-js';

/**
 * AES 解密工具
 * @param {String} ciphertext - 密文 (Hex字符串)
 * @param {String} key - 密钥
 * @returns {String} 解密后的 JSON 字符串
 */
export function decryptAES(ciphertext, key) {
  if (!ciphertext) return '';
  try {
    // 将密钥转换
    var keyBytes = CryptoJS.enc.Utf8.parse(key);
    var ivBytes = CryptoJS.enc.Utf8.parse(key); // 使用相同的IV

    // 将十六进制字符串转换为CryptoJS可用的格式
    var encryptedBytes = CryptoJS.enc.Hex.parse(ciphertext);

    // 解密
    var decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedBytes },
      keyBytes,
      { iv: ivBytes, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );

    // 转换为UTF-8字符串
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.error('解密失败:', e);
    return '';
  }
}